import script from "./ResultSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultSection.vue?vue&type=script&setup=true&lang=js"

import "./ResultSection.vue?vue&type=style&index=0&id=1ee0562c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee0562c"]])

export default __exports__